import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom";
import { AlertComponent } from "../../components/shared/alert.component";
import { NftBoard } from "../../components/web3/nft.board";
import { NftThumbnail } from "../../components/web3/nft.thumbnail";
import User from "../../models/user.model";
import { Web3ContextType } from "../../providers/context.types";
import { Web3Context } from "../../providers/web3.context";
import { AppState } from "../../store/root.reducer"
import { GetVouchers, GetWalletTokens } from "./store/nfts.actions";

export const NFTListPage = () => {
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const user = useSelector((state: AppState) => state.auth.user as User);
    const { nftError } = useSelector((state: AppState) => state.nft);
    const { address } = React.useContext(Web3Context) as Web3ContextType;

    const { walletTokens } = useSelector((state: AppState) => state.nft);

    const navigateToMint = () => {
        navigate('/nft/mint');
    }

    const [error, setError] = React.useState<string>();

    React.useEffect(() => {
        if(!user) setError('Please login to do any NFT actions.');
        // else if(user.wallet.toLocaleLowerCase() !== address.toLocaleLowerCase()) setError('You are using different address with your account. \nPlease change your wallet.');
        else setError(null);
    }, [user, address])


    return (
        <>
            <div className="container">
                {error || nftError ? 
                    <AlertComponent
                        variant="danger"
                        onClose={() => setError(null)}
                        text={error || nftError} /> : <></>
                }
                <div className="row">
                    <div className="col-md-8 mt-5">
                        <NftBoard />
                    </div>
                    <div className="col-md-4  mt-5">
                        {walletTokens.length > 0 && walletTokens.map((nft, index) => 
                        <NftThumbnail 
                            key={index} 
                            name={nft.name} 
                            tokenId={nft.tokenId} 
                            uri={nft.tokenUri} 
                        />)}
                    </div>
                </div>
            </div>
        </>
    )
}